// extracted by mini-css-extract-plugin
export var buttonscontainer = "CmsMapCard-module--buttonscontainer--c40e6";
export var cardcontainer = "CmsMapCard-module--cardcontainer--e879f";
export var cardsectionbreak = "CmsMapCard-module--cardsectionbreak--87e6f";
export var cardtext = "CmsMapCard-module--cardtext--ba53b";
export var heading = "CmsMapCard-module--heading--0635a";
export var htmltext = "CmsMapCard-module--htmltext--0e992";
export var iconWrapper = "CmsMapCard-module--iconWrapper--c0377";
export var nomargin = "CmsMapCard-module--nomargin--efb15";
export var selected = "CmsMapCard-module--selected--56dec";
export var subheading = "CmsMapCard-module--subheading--b4e75";
export var text = "CmsMapCard-module--text--33ff6";
export var textcontainer = "CmsMapCard-module--textcontainer--e3f88";
export var title = "CmsMapCard-module--title--cc2ab headings-module--signpostHeadingSmall--e67c4";